// File path: src/components/common/Navigation.js

import React, { useState } from "react";
import { Nav, Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BoxArrowInUpRight, BoxArrowUpLeft, JournalText, BoxSeamFill, Whatsapp, Bank, Clipboard2DataFill, Speedometer2 } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';
import reymidas from '../../utils/rms.png';
import { useAuthHub } from "../../hooks/usePermisos";

const sections = [  
  {
    key: 'ingresos',
    icon: BoxArrowInUpRight,
    label: 'Ingresos',
    subItems: [
      { to: '/admin/IngresosFacturas/', label: 'Facturas' },
      { to: '/admin/PagosRecibidos/', label: 'Pagos Recibidos' },
      { to: '/admin/Devoluciones/', label: 'Devoluciones' },
      { to: '/admin/Pedidos/', label: 'Pedidos' },
    ],
  },
  {
    key: 'gastos',
    icon: BoxArrowUpLeft,
    label: 'Gastos',
    subItems: [
      { to: '/admin/Compras/', label: 'Facturas de Compra' },
      { to: '/admin/PagosRealizados/', label: 'Pagos Realizados' },
    ],
  },
  {
    key: 'contactos',
    icon: JournalText,
    label: 'Contactos',
    subItems: [
      { to: '/admin/Clientes/', label: 'Clientes' },
      { to: '/admin/Proveedores/', label: 'Proveedores' },
    ],
  },
  {
    key: 'inventario',
    icon: BoxSeamFill,
    label: 'Inventario',
    subItems: [
      { to: '/admin/Categorias/', label: 'Categorias' },
      { to: '/admin/Productos/', label: 'Productos' },
    ],
  },
];

const Sidebar = () => {
  const [hoveredSection, setHoveredSection] = useState(null);

  const handleMouseEnterSection = (key) => {
    setHoveredSection(key);
  };

  const handleMouseLeaveSection = () => {
    setHoveredSection(null);
  };
  const { isAdmin } = useAuthHub();  // Obtén isAdmin desde el hook

  return (
    <div
      className="d-none d-sm-block bg-black text-white sidebar"
      style={{
        position: 'sticky', // Cambiado a fixed
        top: 0,
        height: '100vh',
        zIndex: 1050,    // Asegura que el sidebar quede detrás de la ventana emergente
      }}
    >
      <div className="text-center my-4 header">
        <img src={reymidas} width={60} alt="ReyMidaCaps Logo" />
      </div>
      <hr className="border-light mx-3" />
      <Nav defaultActiveKey="/admin/Dashboard/" className="flex-column">
        {/* Dashboard */}
        <OverlayTrigger placement="right" overlay={<Tooltip>Dashboard</Tooltip>}>
          <Nav.Link
            as={Link}
            to="/admin/Dashboard/"
            className="text-white d-flex align-items-center"
          >
            <Speedometer2 className="m-2" size={24} />
          </Nav.Link>
        </OverlayTrigger>

        {/* Sections */}
        {sections.map((section) => (
          <div
            key={section.key}
            className="nav-item position-relative"
            style={{ zIndex: 1100 }} // Agrega z-index alto al contenedor padre
            onMouseEnter={() => handleMouseEnterSection(section.key)}
            onMouseLeave={handleMouseLeaveSection}
          >
            <Nav.Link className="text-white d-flex align-items-center">
              <section.icon className="m-2" size={24} />
            </Nav.Link>
            {hoveredSection === section.key && (
              <div
                className="position-absolute start-100 top-0 bg-light border rounded shadow p-2 bg-black"
                style={{
                  minWidth: '200px',
                  zIndex: 2050, // Aumenta el z-index de la ventana emergente
                }}
              >
                <Card className="border-0 bg-black">
                  <Card.Body className="p-2">
                    {section.subItems.map((subItem) => (
                      <Nav.Link
                        as={Link}
                        to={subItem.to}
                        key={subItem.to}
                        className="text-light p-2 rounded"
                      >
                        {subItem.label}
                      </Nav.Link>
                    ))}
                  </Card.Body>
                </Card>
              </div>
            )}
          </div>
        ))}

        {/* Sucursales */}
        <OverlayTrigger placement="right" overlay={<Tooltip>Sucursales</Tooltip>}>
          <Nav.Link
            as={Link}
            to="/admin/Sucursales/"
            className="text-white d-flex align-items-center"
          >
            <Whatsapp className="m-2" size={24} />
          </Nav.Link>
        </OverlayTrigger>

        {/* Bancos */}
        <OverlayTrigger placement="right" overlay={<Tooltip>Bancos</Tooltip>}>
          <Nav.Link
            as={Link}
            to="/admin/Bancos/"
            className="text-white d-flex align-items-center"
          >
            <Bank className="m-2" size={24} />
          </Nav.Link>
        </OverlayTrigger>

        {/* Reportes */}
        {isAdmin() && (
          <OverlayTrigger placement="right" overlay={<Tooltip>Reportes</Tooltip>}>
            <Nav.Link
              as={Link}
              to="/admin/Reportes/"
              className="text-white d-flex align-items-center"
            >
              <Clipboard2DataFill className="m-2" size={24} />
            </Nav.Link>
          </OverlayTrigger>
        )}

      </Nav>
    </div>
  );
};

export default Sidebar;
